import { ISharedFileRequestSettingsResponse } from "@wingspanhq/shared-files/dist/lib/interfaces";

export function getSharedFileDefaultValues(
  data: ISharedFileRequestSettingsResponse
) {
  return {
    instructions: data.instructions || ""
  };
}
